import { ApplicationRef, inject, InjectionToken } from '@angular/core';
import { Socket, SocketIoConfig } from 'ngx-socket-io';
import { environment } from '../environments/environment';

export const CHATS_SOCKET = new InjectionToken<Socket>('ChatsSocket');

// Socket configurations
const chatsSocketConfig: SocketIoConfig = {
  url: `${environment.appApiUrl}/chats`,
  options: {
    autoConnect: false,
    reconnection: true,
    closeOnBeforeunload: true,
    withCredentials: true,
    protocols: ['polling', 'websocket'],
    upgrade: true,
  },
};

export const provideChatsSocket = () => [
  {
    provide: CHATS_SOCKET,
    useFactory: () => new Socket(chatsSocketConfig, inject(ApplicationRef)),
  },
];
